<section class="intro">
  <div class="container">
    <h2 class="intro__title">
      Home
      <span class="intro__title__subtitle">Welcome HVAC Contractors</span>
    </h2>
  </div>
</section>

<section class="stepper-section">
  <ul class="stepper curser-pointer">
    <li [routerLink]="['/equipment']" class="equipment stepper__item">
      <span class="stepper__item__icon">
        <i title="equipment">
          <img src="../assets/images/equipment.png" alt="" />
        </i>
      </span>
      <span class="stepper__item__title">
        <a class=" stepper__item__title__link">
          <span class="stepper__item__title__link__text">Equipment<a href="https://inspexn.s3.amazonaws.com/Equipment_page.png" target="blank" (click)="stayHome()"><fa-icon class="hoverIcon" [icon]="fainfo" style='color:rgb(255, 255, 255);cursor:help;'></fa-icon></a></span>
        </a>
      </span>
    </li>
    <li [routerLink]="['/design']" class="equipment stepper__item">
      <span class="stepper__item__icon">
        <i href="#" title="">
          <img src="../assets/images/design.png" alt="" />
        </i>
      </span>
      <span class="stepper__item__title">
        <a  class="stepper__item__title__link" title="design">
          <span class="stepper__item__title__link__text"> Designs<a href="https://inspexn.s3.amazonaws.com/Designs.png" target="blank" (click)="stayHome()"><fa-icon class="hoverIcon" [icon]="fainfo" style='color:rgb(255, 255, 255);cursor:help;'></fa-icon></a></span>
        </a>
      </span>
    </li>
    <li [routerLink]="['/system']" class="equipment stepper__item">
      <span class="stepper__item__icon">
        <i title="systems">
          <img src="../assets/images/systems.png" alt="" />
        </i>
      </span>
      <span class="stepper__item__title" style="width: 85%;">
        <a class="stepper__item__title__link">
          <span class="stepper__item__title__link__text"> Systems<a href="https://inspexn.s3.amazonaws.com/Systems.png" target="blank" (click)="stayHome()"><fa-icon class="hoverIcon" [icon]="fainfo" style='color:rgb(255, 255, 255);cursor:help;'></fa-icon></a></span>
        </a>
      </span>
    </li>
    <li [routerLink]="['/hvacLocations']" class="equipment stepper__item">
      <span class="stepper__item__icon">
        <i>
          <img src="../assets/images/homes.png" alt="" />
        </i>
      </span>
      <span class="stepper__item__title">
        <a class="stepper__item__title__link">
          <span class="stepper__item__title__link__text"> Locations</span>
        </a>
      </span>
    </li>
  </ul>
</section>
<section class="video-wrapper">
  <div class="container">
    <h2 class="video-wrapper__title">
      Need Help?
      <span class="video-wrapper__title__subtitle"> </span>
    </h2>

    <div class="video-wrapper__links">
      <button class="video-wrapper__help-btn video">Watch Tutorial</button>
      <button class="video-wrapper__help-btn chat" (click)="openContactForm()">Contact Us</button>
    </div>


    <!--
    <div id="carouselExampleIndicators" class="carousel slide mt-5" data-bs-ride="carousel">
      <div class="carousel-inner">
        <div class="carousel-item active">
          <img src="../../assets/images/video.png" class="d-block w-100" alt="..." />
        </div>
        <div class="carousel-item">
          <img src="../../assets/images/video.png" class="d-block w-100" alt="..." />
        </div>
        <div class="carousel-item">
          <img src="../../assets/images/video.png" class="d-block w-100" alt="..." />
        </div>
      </div>
      <button class="carousel-control-prev" type="button" data-bs-target="#carouselExampleIndicators"
        data-bs-slide="prev">
        <span class="carousel-control-prev-icon" aria-hidden="true"></span>
        <span class="visually-hidden">Previous</span>
      </button>
      <button class="carousel-control-next" type="button" data-bs-target="#carouselExampleIndicators"
        data-bs-slide="next">
        <span class="carousel-control-next-icon" aria-hidden="true"></span>
        <span class="visually-hidden">Next</span>
      </button>
      <div class="carousel-indicators">
        <button type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide-to="0" class="active"
          aria-current="true" aria-label="Slide 1">
          <img src="../../assets/images/video-thumbnail.jpg" alt="" srcset="" />
        </button>
        <button type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide-to="1" aria-label="Slide 2">
          <img src="../../assets/images/video-thumbnail.jpg" alt="" srcset="" />
        </button>
        <button type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide-to="2" aria-label="Slide 3">
          <img src="../../assets/images/video-thumbnail.jpg" alt="" srcset="" />
        </button>
      </div>
    </div>
-->


  </div>
</section>
